import {useEffect, useRef, useState} from "react";
import {PostItem} from "./postItem";
import {useTranslation} from "react-i18next";


const PostList = ({ apiCall, posts, bookmarks,cursor,users, onGeoClick }) => {

    const { t } = useTranslation();
    const [page, setPage] = useState(1);

    const loader = useRef(null);

    useEffect(() => {
        let options = {
            root: document.querySelector('body'),
            rootMargin: "50px",
            threshold: 0
        };

        const observer = new IntersectionObserver(handleObserver, options);
        if (loader.current) {
            observer.observe(loader.current)
        }
    }, []);

    useEffect(() => {
        if(apiCall!==false){
            apiCall();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page])

    const handleObserver = (entities) => {
        const target = entities[0];

        if (target.isIntersecting) {
            setPage((page) => page + 1)
        }
    };

    return (<div className="post-list-container" >
        <div className="post-list">
            {
              posts.map((post, index) => {
                  return <PostItem users={users} bookMarked={bookmarks.some(id=> id === post.id)}
                                   post={post} key={post.id} isListItem={true} onGeoClick={onGeoClick} />
              })
            }
            { posts.length === 0 ? <div>{t('Aucun éléments à afficher')}</div> : "" }
            { posts.length > 0 && apiCall !== false && <div className="loading" ref={loader}>
                <h2 className={cursor!==false? "": "hide"}>{t('Chargement')}</h2>
            </div>}
        </div>
    </div>)
}

export { PostList };
